/* @jsx h */
import { defineComponent, h } from "vue";
import type { RestaurantProfileData } from "../types";

export const SocialLinksSection = defineComponent<{
  data: RestaurantProfileData;
  onUpdate: <K extends keyof RestaurantProfileData>(field: K, value: RestaurantProfileData[K]) => void;
}>({
  name: "SocialLinksSection",
  props: ["data", "onUpdate"],
  setup(props) {
    const renderInput = (
      label: string,
      placeholder: string,
      key: keyof NonNullable<RestaurantProfileData["socials"]>,
      icon: string,
    ) => (
      <div>
        <label class="block text-sm font-medium text-base-content/80 mb-2">{label}</label>
        <div class="relative">
          <span class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-base-content/40 text-lg">
            {icon}
          </span>
          <input
            type="url"
            value={props.data.socials?.[key] ?? ""}
            onInput={(e) =>
              props.onUpdate("socials", {
                ...props.data.socials,
                [key]: (e.target as HTMLInputElement).value,
              })
            }
            class="input input-bordered w-full bg-base-200 focus:bg-base-100 transition-colors pl-10"
            placeholder={placeholder}
          />
        </div>
      </div>
    );

    return () => (
      <div class="bg-base-100 l-box-shadow  rounded-xl p-6 shadow-sm border ">
        <div class="flex items-center gap-3 mb-6">
          <div class="w-10 h-10 rounded-lg bg-error/20 flex items-center justify-center">
            <span class="material-symbols-outlined text-accent text-xl">share</span>
          </div>
          <div>
            <h3 class="text-lg font-semibold text-accent">Digital Presence</h3>
            <p class="text-sm text-base-content/60">Connect your profiles so guests can follow and engage.</p>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          {renderInput("Facebook", "https://facebook.com/yourpage", "facebook", "public")}
          {renderInput("Instagram", "https://instagram.com/yourhandle", "instagram", "photo_camera")}
          {renderInput("LinkedIn", "https://linkedin.com/company/yourbrand", "linkedin", "work")}
          {renderInput("Website", "https://yourrestaurant.com", "website", "language")}
        </div>
        <p class="text-xs text-base-content/50 mt-3">
          Links appear on guest-facing experiences and receipts where available.
        </p>
      </div>
    );
  },
});
